import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import jqueryDataUtil from "@/common/jqueryDataUtil";
import { simpleAlert } from "@/pages/modules/alerts";
import { getUserIdFromClientId } from "@/common/clientIdUtils";
import ChatBox from "../ChatBox/ChatBox";
import BroadsideTool from "../BroadsideTool/BroadsideTool";
import { Contact } from "@/models/Contact";
import UserSession from "../../UserSession";
import store from "@/store/store";
import { dispatchThunk } from "@/store/dispatchThunk";
import Draggable from "react-draggable";
import { contactsInListSelector, currentContactSelector, sortedContactsSelector } from "@/store/chat/contacts/Selectors";
import { startChatWith } from "@/store/chat/contacts/Actions";
import { initializeIm } from "@/store/chat/im/Actions";
import { basicAccountInfoManager } from "@/pages/base/basicAccountInfoManager";
import { ensureAttributesForSelector } from "@/pages/base/utils";
import { getChatWindowPosition, saveChatWindowPosition } from "./chatWindowPosition";
import { getAuthHash } from "@/pages/base/base";
import platform from "platform";
import { saveContactsToStorage } from "@/store/persistedContactIds";
import { assert } from "@/common/assert";
import { IS_CRA, IS_DEV } from "@/common/fhtGlobalEnv";
import { AccountApiApi } from "@/apis/api/AccountApiApi";
import { CmsApiApi } from "@/apis/api/CmsApiApi";
var isIE = platform.name === "IE";

function ExampleContacts(props) {
  return _jsxs("div", {
    children: [_jsx("br", {}, void 0), _jsx("br", {}, void 0), _jsx("button", __assign({
      className: "js-start-chat",
      "data-user-client-id": "2_b117454aecd75b35",
      "data-is-mobile-user": "true"
    }, {
      children: "He Qinghua"
    }), void 0), _jsx("button", __assign({
      className: "js-start-chat",
      "data-user-client-id": "1_2a20bca9345bf048",
      "data-is-mobile-user": "true"
    }, {
      children: "Yuan Jian"
    }), void 0), _jsx("button", __assign({
      className: "js-start-chat",
      "data-user-client-id": "4_039ce887230fc289",
      "data-is-mobile-user": "true"
    }, {
      children: "Zhang Menglai"
    }), void 0), _jsx("button", __assign({
      className: "js-start-chat",
      "data-user-client-id": "1009_8011e607a3b3c3fa",
      "data-is-mobile-user": "true"
    }, {
      children: "TemporaryChatDisabled"
    }), void 0), _jsx("button", __assign({
      onClick: function onClick() {
        return saveContactsToStorage(props.myself, []);
      }
    }, {
      children: "Reset Contacts In localstorage"
    }), void 0)]
  }, void 0);
}

var ChatApp =
/** @class */
function (_super) {
  __extends(ChatApp, _super);

  function ChatApp(props) {
    var _this = _super.call(this, props) || this;

    _this.getOwnState = function () {
      var state = store.getState();
      var sortedContacts = sortedContactsSelector(state);

      if (IS_DEV) {
        sortedContacts.forEach(function (c) {
          assert(c instanceof Contact, "invalid Contact instance!");
        });
      }

      return {
        isChatBoxOpen: state.imSession.isChatBoxOpen,
        myself: state.imSession.myself,
        currentContact: currentContactSelector(state),
        contactsInList: contactsInListSelector(state),
        sortedContacts: sortedContacts
      };
    };

    _this.onStoreChange = function () {
      var state = store.getState();

      var ownState = _this.getOwnState();

      _this.setState(ownState);
    };

    _this.handleMessageToSend = function (msg) {
      return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          return [2
          /*return*/
          ];
        });
      });
    };

    _this.handleDragStop = function (e, data) {
      saveChatWindowPosition({
        x: data.x,
        y: data.y
      });
    };

    _this.state = __assign(__assign({}, _this.getOwnState()), {
      companyId: 0,
      defaultCustomerService: {
        clientId: "",
        userId: 0,
        isMobileUser: true
      }
    });
    return _this;
  }

  ChatApp.prototype.componentDidMount = function () {
    return __awaiter(this, void 0, void 0, function () {
      function getCompanyCustomerSvcList(cId) {
        var _a;

        return __awaiter(this, void 0, void 0, function () {
          var res, defaultCustomerSvc;
          return __generator(this, function (_b) {
            switch (_b.label) {
              case 0:
                return [4
                /*yield*/
                , cmsApi.cmsApiGetCustomerServicesOfCompanyId({
                  companyId: cId
                })];

              case 1:
                res = _b.sent();
                console.log("company customer svcs", res.length, res);
                defaultCustomerSvc = res[0];
                that.setState({
                  defaultCustomerService: {
                    clientId: defaultCustomerSvc.ClientId,
                    userId: defaultCustomerSvc.UserId,
                    isMobileUser: defaultCustomerSvc.IsMobileUser
                  }
                });

                if (that.state.defaultCustomerService.userId === ((_a = store.getState().imSession.myself) === null || _a === void 0 ? void 0 : _a.userId)) {
                  simpleAlert("不能和自己聊天！");
                } else {
                  dispatchThunk(store, startChatWith(that.state.defaultCustomerService.clientId));
                }

                return [2
                /*return*/
                ];
            }
          });
        });
      }

      var cmsApi, that, info, accountApi, info, pos;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.unsubscribe = store.subscribe(this.onStoreChange);
            ensureAttributesForSelector(".js-start-chat", ["data-user-client-id", "data-is-mobile-user"]);
            $(document).on("mouseenter", ".js-start-chat", function () {
              $(this).css("cursor", "pointer");
            });
            $(document).on("click", ".js-start-chat", function (event) {
              var _a;

              var $chatBtn = $(this);
              var otherClientId = jqueryDataUtil.requiredString($chatBtn, "user-client-id");
              var isMobileUser = jqueryDataUtil.requiredBoolean($chatBtn, "is-mobile-user");
              var otherUserId = getUserIdFromClientId(otherClientId);

              if (otherUserId === ((_a = store.getState().imSession.myself) === null || _a === void 0 ? void 0 : _a.userId)) {
                simpleAlert("不能和自己聊天！");
              } else if (!isMobileUser) {
                simpleAlert("该用户不是移动端用户，不能聊天");
              } else {
                dispatchThunk(store, startChatWith(otherClientId));
              }
            });
            cmsApi = new CmsApiApi();
            that = this;
            $(document).on("click", ".js-start-company-chat", function (event) {
              var $startCompanyChatBtn = $(this);
              $startCompanyChatBtn.css("cursor", "pointer");
              var companyId = jqueryDataUtil.requiredNumber($startCompanyChatBtn, "company-id");
              that.setState({
                companyId: companyId
              });

              if (that.state.companyId) {
                getCompanyCustomerSvcList(that.state.companyId);
              }
            });
            if (!!IS_CRA) return [3
            /*break*/
            , 2];
            return [4
            /*yield*/
            , basicAccountInfoManager.getBasicAccountInfo()];

          case 1:
            info = _a.sent();
            console.log("NOT CRA, LOAD INFO", info);
            dispatchThunk(store, initializeIm(info));
            return [3
            /*break*/
            , 5];

          case 2:
            IS_DEV && console.log("IS CRA, CHECK TOKEN");
            if (!store.getState().loginSession.token) return [3
            /*break*/
            , 4];
            accountApi = new AccountApiApi();
            return [4
            /*yield*/
            , accountApi.accountApiBasicAccountInfo({
              "hash.authHash": getAuthHash()
            })];

          case 3:
            info = _a.sent();
            dispatchThunk(store, initializeIm(info));
            return [3
            /*break*/
            , 5];

          case 4:
            console.log("the chatter is a tourist");
            dispatchThunk(store, initializeIm({}));
            _a.label = 5;

          case 5:
            return [4
            /*yield*/
            , getChatWindowPosition()];

          case 6:
            pos = _a.sent();

            if (pos) {
              console.log("INITIAL chat window pos:", pos);
              this.setState({
                pos: pos
              });
            }

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  ChatApp.prototype.componentWillUnmount = function () {
    this.unsubscribe && this.unsubscribe();
  };

  ChatApp.prototype.render = function () {
    return _jsx("div", {
      children: _jsxs("div", __assign({
        style: {
          position: "fixed",
          left: 0,
          top: 0,
          width: 0,
          height: 0,
          zIndex: 11000
        }
      }, {
        children: [IS_CRA && _jsx(UserSession, {}, void 0), IS_CRA && this.state.myself && _jsx(ExampleContacts, {
          myself: this.state.myself
        }, void 0), !IS_CRA && !isIE && this.state.isChatBoxOpen && this.state.currentContact && _jsx(Draggable, __assign({
          handle: ".handle",
          bounds: "body",
          onStop: this.handleDragStop,
          defaultPosition: this.state.pos || {
            x: 100,
            y: 100
          }
        }, {
          children: _jsx("div", {
            children: _jsx(ChatBox, {}, void 0)
          }, void 0)
        }), void 0), IS_CRA && !isIE && this.state.isChatBoxOpen && this.state.currentContact && _jsx(Draggable, __assign({
          handle: ".handle",
          bounds: "body",
          onStop: this.handleDragStop,
          defaultPosition: this.state.pos || {
            x: 100,
            y: 0
          }
        }, {
          children: _jsx("div", {
            children: _jsx(ChatBox, {}, void 0)
          }, void 0)
        }), void 0), isIE && this.state.isChatBoxOpen && this.state.currentContact && _jsx("div", __assign({
          style: {
            position: "absolute",
            left: 100,
            top: 100
          }
        }, {
          children: _jsx(ChatBox, {}, void 0)
        }), void 0), _jsx(BroadsideTool, {}, void 0)]
      }), void 0)
    }, void 0);
  };

  return ChatApp;
}(React.Component);

export default ChatApp;